import { render, staticRenderFns } from "./noticepage.vue?vue&type=template&id=125365d8&scoped=true&"
import script from "./noticepage.vue?vue&type=script&lang=js&"
export * from "./noticepage.vue?vue&type=script&lang=js&"
import style0 from "./noticepage.vue?vue&type=style&index=0&id=125365d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125365d8",
  null
  
)

export default component.exports